import React from 'react'
import styled from 'styled-components'
import Link from 'gatsby-link'

const Wrapper = styled.div`
  display: flex;
  max-width: 300px;
  justify-content: flex-end;
  align-items: center;
  flex-wrap: wrap;
`

const StyledLink = styled(Link)`
  margin: 5px;
  text-decoration: none;
  border: solid 1px ${({ theme }) => theme.colors.base};
  padding: 3px 10px;
  border-radius: 3px;
  &:hover {
    color: ${({ theme }) => theme.colors.base};
  }
`

const links = [
  { title: 'Home', slug: '/' },
  { title: 'What We Do', slug: '/what' },
  { title: 'How We Do It', slug: '/how-we-do-it' },
  { title: 'Privacy', slug: '/privacy' },
]

const SiteMap = () => (
  <Wrapper>
    {links.map(link => (
      <StyledLink key={link.slug} to={link.slug}>
        {link.title}
      </StyledLink>
    ))}
  </Wrapper>
)

export default SiteMap



// WEBPACK FOOTER //
// ./src/components/SiteMap.js